import { render, staticRenderFns } from "./NotificationsHeader.vue?vue&type=template&id=6d83a926"
import script from "./NotificationsHeader.vue?vue&type=script&lang=js"
export * from "./NotificationsHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports